export var getTimeOptions = function (fromDate, numIntervals, intervalMinutes, format) {
    if (format === void 0) { format = 'h:mm ZZZZ'; }
    var timeOptions = new Array(numIntervals).fill('').map(function (x, i) {
        return {
            label: fromDate.plus({ minutes: i * intervalMinutes }).toFormat(format),
            value: fromDate
                .plus({ minutes: i * intervalMinutes })
                .toUTC()
                .toISO(),
            dateValue: fromDate.plus({ minutes: i * intervalMinutes }),
        };
    });
    return timeOptions;
};
export var useTimeOptions = function (fromDate, numIntervals, intervalMinutes, format) {
    if (format === void 0) { format = 'h:mm ZZZZ'; }
    return getTimeOptions(fromDate, numIntervals, intervalMinutes, format);
};
